export const DEMO_VENDORS_REQUIRING_PLAID_RECONNECTION = {
  CORRIGO: 'demo-mode-select-direct-debit-corrigo',
  ITRADE: 'demo-mode-select-direct-debit-itrade',
  DD_NET30: 'demo-mode-select-direct-debit-net30',
} as const;
